import { useNavigate } from 'react-router-dom';

function DashboardMockup() {
  return (
    <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-soft-xl overflow-hidden border border-gray-100">
      {/* Dashboard Header */}
      <div className="bg-deep-navy-500 px-4 md:px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="w-7 h-7 rounded-md bg-dark-teal-500 flex items-center justify-center text-white text-xs font-bold">S</span>
          <span className="text-white text-sm font-semibold">SpaProBridge Dashboard</span>
        </div>
        <div className="flex items-center gap-2 md:gap-4">
          <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 bg-white/10 rounded-full">
            <i className="ri-coins-line text-soft-gold-400 text-xs" />
            <span className="text-white text-xs font-medium">12 Kredi</span>
          </div>
          <div className="w-7 h-7 rounded-full bg-soft-gold-500/20 flex items-center justify-center">
            <i className="ri-notification-3-line text-white text-xs" />
          </div>
        </div>
      </div>

      <div className="p-3 md:p-5 grid grid-cols-1 lg:grid-cols-3 gap-3 md:gap-4">
        {/* Left: Therapist Cards */}
        <div className="lg:col-span-2 space-y-3">
          <div className="flex items-center justify-between mb-1">
            <h3 className="text-xs font-semibold text-deep-navy-500">Eşleşen Terapistler</h3>
            <span className="text-xs text-gray-400">3 yeni öneri</span>
          </div>

          {/* Therapist Card 1 */}
          <div className="flex items-center gap-3 p-3 bg-off-white rounded-xl border border-gray-100">
            <div className="w-10 h-10 rounded-full bg-dark-teal-100 flex items-center justify-center text-dark-teal-500 text-sm font-bold">
              A.K.
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-deep-navy-500">A.K.</span>
                <span className="px-1.5 py-0.5 bg-soft-gold-100 text-soft-gold-700 text-[10px] font-medium rounded-full">Masaj</span>
              </div>
              <p className="text-xs text-gray-400 truncate">Antalya · 5 yıl deneyim</p>
            </div>
            <div className="flex items-center gap-1.5 px-2 py-1 bg-dark-teal-50 rounded-lg">
              <span className="text-xs font-bold text-dark-teal-500">94%</span>
              <span className="text-[10px] text-gray-400">Uyum</span>
            </div>
          </div>

          {/* Therapist Card 2 */}
          <div className="flex items-center gap-3 p-3 bg-off-white rounded-xl border border-gray-100">
            <div className="w-10 h-10 rounded-full bg-soft-gold-100 flex items-center justify-center text-soft-gold-700 text-sm font-bold">
              M.Y.
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-deep-navy-500">M.Y.</span>
                <span className="px-1.5 py-0.5 bg-dark-teal-100 text-dark-teal-600 text-[10px] font-medium rounded-full">Cilt Bakımı</span>
              </div>
              <p className="text-xs text-gray-400 truncate">İstanbul · 3 yıl deneyim</p>
            </div>
            <div className="flex items-center gap-1.5 px-2 py-1 bg-dark-teal-50 rounded-lg">
              <span className="text-xs font-bold text-dark-teal-500">87%</span>
              <span className="text-[10px] text-gray-400">Uyum</span>
            </div>
          </div>

          {/* Therapist Card 3 - Sessiz Kariyer */}
          <div className="flex items-center gap-3 p-3 bg-off-white rounded-xl border border-gray-100 opacity-70">
            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-sm font-bold">
              <i className="ri-eye-off-line" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-deep-navy-500">Sessiz Mod</span>
                <span className="px-1.5 py-0.5 bg-gray-100 text-gray-500 text-[10px] font-medium rounded-full">Gizli Profil</span>
              </div>
              <p className="text-xs text-gray-400 truncate">Sadece uyumlu işletmelere görünür</p>
            </div>
            <div className="flex items-center gap-1.5 px-2 py-1 bg-gray-50 rounded-lg">
              <span className="text-xs font-bold text-gray-400">--</span>
              <span className="text-[10px] text-gray-400">Uyum</span>
            </div>
          </div>
        </div>

        {/* Right: Pending & CRM */}
        <div className="space-y-3">
          <div className="bg-off-white rounded-xl p-3 border border-gray-100">
            <h3 className="text-xs font-semibold text-deep-navy-500 mb-2">Bekleyen Talepler</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2 p-2 bg-white rounded-lg">
                <div className="w-2 h-2 rounded-full bg-soft-gold-500" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-deep-navy-500 truncate">Spa Merkezi Ataköy</p>
                  <p className="text-[10px] text-gray-400">İletişim talebi gönderdi</p>
                </div>
              </div>
              <div className="flex items-center gap-2 p-2 bg-white rounded-lg">
                <div className="w-2 h-2 rounded-full bg-dark-teal-500" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-deep-navy-500 truncate">Wellness Hotel Kaya</p>
                  <p className="text-[10px] text-gray-400">Personel ihtiyacı eşleşti</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-off-white rounded-xl p-3 border border-gray-100">
            <h3 className="text-xs font-semibold text-deep-navy-500 mb-2">CRM Kategorileri</h3>
            <div className="flex flex-wrap gap-1.5">
              <span className="px-2 py-1 bg-white text-[10px] font-medium text-deep-navy-500 rounded-md border border-gray-100">Favoriler (4)</span>
              <span className="px-2 py-1 bg-white text-[10px] font-medium text-deep-navy-500 rounded-md border border-gray-100">Görüşülen (2)</span>
              <span className="px-2 py-1 bg-white text-[10px] font-medium text-deep-navy-500 rounded-md border border-gray-100">Gizli (1)</span>
              <span className="px-2 py-1 bg-white text-[10px] font-medium text-deep-navy-500 rounded-md border border-gray-100">Aktif (3)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full bg-off-white pt-20 md:pt-24 lg:pt-28 pb-12 md:pb-16 lg:pb-20 overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `radial-gradient(circle at 1px 1px, #0a1628 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} />

      <div className="relative w-full px-4 md:px-8 lg:px-12">
        {/* Text Content */}
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-deep-navy-500 leading-tight mb-5 md:mb-6">
            Spa ve wellness sektöründe{' '}
            <span className="text-dark-teal-500">güvenli</span> terapist eşleşme platformu
          </h1>
          <p className="text-base md:text-lg text-gray-500 leading-relaxed mb-7 md:mb-9 max-w-2xl mx-auto">
            SpaProBridge, profesyonel terapistler ile spa işletmelerini gizlilik, güven ve kontrollü iletişim altyapısı ile buluşturur.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <button
              onClick={() => navigate('/terapist-kayit')}
              className="w-full sm:w-auto px-7 py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors shadow-soft cursor-pointer whitespace-nowrap"
            >
              Terapist Olarak Kayıt Ol
            </button>
            <button
              onClick={() => navigate('/spa-kayit')}
              className="w-full sm:w-auto px-7 py-3.5 rounded-full text-sm font-semibold text-deep-navy-500 border-2 border-deep-navy-500 hover:bg-deep-navy-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Spa İşletmesi Olarak Başvur
            </button>
          </div>
        </div>

        {/* Dashboard Mockup */}
        <div className="relative">
          <DashboardMockup />
          {/* Decorative glow */}
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-3/4 h-40 bg-soft-gold-400/10 rounded-full blur-3xl pointer-events-none" />
        </div>
      </div>
    </section>
  );
}